import { useEffect, useRef } from 'react';
import { AutoSizer,List, WindowScroller } from 'react-virtualized';

import useScreenSize from '@/hooks/useScreenSize';
import InfiniteScroll from '@/shared-components/lists/components/InfiniteScroll';

import Row from './Row';

import './styles/VirtualList.css';

export default function VirtualList({ items, onLoadMore, searchLimited = false }) {
  const screenSize = useScreenSize();
  const listRef = useRef();

  useEffect(() => {
    listRef.current.recomputeRowHeights();
  }, [screenSize.width]);

  return (
    <>
      <div className="search-view-users-virtual-list">
        <InfiniteScroll 
          className="search-view-users-remove-scrollbar" 
          onLoadMore={onLoadMore} 
          shouldLoadMore={items.data.length < items.totalDocs} 
          offsetElements={3} 
          listLength={items.data.length} 
          defaultInfiniteLoaderClassName="search-view-users-virtual-list-loader"
        >
          {({ infiniteScrollAssigner, infiniteScrollParent }) => (
            <WindowScroller scrollElement={infiniteScrollParent ? infiniteScrollParent : window}>
              {({ height, isScrolling, onChildScroll, scrollTop }) => (
                <AutoSizer disableHeight>
                  {({ width }) => (
                    <List
                      autoHeight
                      width={width}
                      height={height}
                      isScrolling={isScrolling}
                      onScroll={onChildScroll}
                      rowCount={items.data.length}
                      rowHeight={searchLimited ? 115 : 120}
                      scrollTop={scrollTop}
                      overscanRowCount={3}
                      ref={listRef}
                      rowRenderer={({ index, key }) => {
                        const isLastItem = index === items.data.length - 1;
                        return (
                          <div
                            className={`search-view-users-rows ${isLastItem && searchLimited ? 'search-view-users-rows--last' : ''}`}
                            key={key}
                            ref={infiniteScrollAssigner(index)}
                          >
                            <Row data={items.data[index]} />
                          </div>
                        );
                      }}
                    />
                  )}
                </AutoSizer>
              )}
            </WindowScroller>
          )}
        </InfiniteScroll>
      </div>
    </>
  );
}
